import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/catalog/products")({
	component: () => <Outlet />,
});
